import React, { useState, useEffect } from "react";
import { PAGES } from "./data/constants";
import { TALENT_POOL } from "./data/talents";

// 🌟 引入刚抽离的核心游戏大脑 Hook
import useGameEngine from "./hooks/useGameEngine";

import LeftPanel from "./components/LeftPanel";
import CenterPanel from "./components/CenterPanel";
import FloatingMenu from "./components/FloatingMenu";
import GlobalModals from "./components/GlobalModals";
import PhoneOS from "./components/PhoneOS";
import IntroPage from "./pages/IntroPage";
import SelectPage from "./pages/SelectPage";
import EndPage from "./pages/EndPage";
import "./App.css";

export default function App() {
  const [page, setPage] = useState(PAGES.INTRO);
  const [isFading, setIsFading] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [activeApp, setActiveApp] = useState(isMobile ? "terminal" : "news");
  const [modalType, setModalType] = useState(null);

  // 🌟 核心跳转路由器：交由 Hook 内部在适当的时候调用
  const changePage = (newPage) => {
    setIsFading(true);
    setTimeout(() => {
      setPage(newPage);
      setIsFading(false);
    }, 400);
  };

  // 🌟 初始化游戏大脑，接管所有核心逻辑！
  const {
    state, event, ending, isGenerating, phoneData, unread, hackState,
    karma, unlockedEndings, selectedTalents, logs, terminalEndRef, hackStateRef,
    handleToggleTalent, handleModelSelect, buyItem, handleHackResult, choose, handlePhoneAction, setHackState
  } = useGameEngine(changePage);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleGlobalShare = async () => {
    const shareText = `我在AI横行的世界里当码奸，被资本和AI按在地上摩擦！\n你能活过第几周？快来挑战：`;
    const shareUrl = window.location.href;
    if (navigator.share) {
      try { await navigator.share({ title: '《码奸》- 解放前端兄弟', text: shareText, url: shareUrl }); } catch (err) { }
    } else {
      try {
        await navigator.clipboard.writeText(`${shareText}\n${shareUrl}`);
        alert("📋 游戏链接已复制到剪贴板！快去发给群友们一起卷！");
      } catch (err) { alert("复制失败，请手动复制浏览器链接~"); }
    }
  };

  return (
    <>
      <GlobalModals
        isGenerating={isGenerating} event={event} page={page} hackState={hackState}
        isMobile={isMobile} choose={choose} modalType={modalType} setModalType={setModalType}
      />

      <div className={`page-transition ${isFading ? 'page-fade-out' : 'page-fade-in'}`}>
        {page === PAGES.INTRO && <IntroPage onNext={() => changePage(PAGES.SELECT)} />}

        {page === PAGES.SELECT && (
          <SelectPage onSelect={handleModelSelect} karma={karma} talents={TALENT_POOL} activeTalents={selectedTalents} onToggleTalent={handleToggleTalent} />
        )}

        {page === PAGES.END && (
          <EndPage ending={ending} unlockedEndings={unlockedEndings} historyLog={state.historyLog} onRestart={() => window.location.reload()} onShowModal={setModalType} onShare={handleGlobalShare} />
        )}

        {page === PAGES.GAME && (
          <>
            {state.san <= 20 && <div className="blood-overlay" />}
            {isMobile ? (
              <div style={{ display: 'flex', flexDirection: 'column', height: '100vh', background: '#000' }}>
                <div style={{ flex: 1, overflowY: 'auto', padding: '15px 15px 0 15px', paddingBottom: '30px' }} className={`no-select ${state.san <= 20 ? 'san-critical' : state.san <= 40 ? 'san-low' : ''}`}>
                  {activeApp === 'status' && <LeftPanel state={state} buyItem={buyItem} />}
                  {activeApp === 'terminal' && <CenterPanel state={state} event={event} isGenerating={isGenerating} isMobile={isMobile} choose={choose} hackState={hackState} hackStateRef={hackStateRef} setHackState={setHackState} handleHackResult={handleHackResult} logs={logs} terminalEndRef={terminalEndRef} />}
                  {['news', 'sms', 'mail', 'settings', 'stocks'].includes(activeApp) && (
                    <PhoneOS isMobile={true} phoneData={phoneData} activeApp={activeApp} unread={unread} state={state} openApp={setActiveApp} onPhoneAction={handlePhoneAction} />
                  )}
                </div>
                {/* 移动端底部导航 */}
                <div className="mobile-nav">
                  <div className="nav-item" onClick={() => setActiveApp('terminal')} style={{ opacity: activeApp === 'terminal' ? 1 : 0.5 }}><span style={{ fontSize: 20, marginBottom: 2 }}>💻</span><span>主线</span></div>
                  <div className="nav-item" onClick={() => setActiveApp('status')} style={{ opacity: activeApp === 'status' ? 1 : 0.5 }}><span style={{ fontSize: 20, marginBottom: 2 }}>📊</span><span>状态</span></div>
                  <div className="nav-item" onClick={() => setActiveApp('news')} style={{ opacity: activeApp === 'news' ? 1 : 0.5 }}><span style={{ fontSize: 20, marginBottom: 2 }}>🔥</span><span>行业</span>{unread.news > 0 && <span className="nav-badge">{unread.news}</span>}</div>
                  <div className="nav-item" onClick={() => setActiveApp('sms')} style={{ opacity: activeApp === 'sms' ? 1 : 0.5 }}><span style={{ fontSize: 20, marginBottom: 2 }}>💬</span><span>消息</span>{unread.sms > 0 && <span className="nav-badge">{unread.sms}</span>}</div>
                  <div className="nav-item" onClick={() => setActiveApp('mail')} style={{ opacity: activeApp === 'mail' ? 1 : 0.5 }}><span style={{ fontSize: 20, marginBottom: 2 }}>✉️</span><span>邮件</span>{unread.mail > 0 && <span className="nav-badge">{unread.mail}</span>}</div>
                </div>
              </div>
            ) : (
              <div className={`game-layout no-select ${state.san <= 20 ? 'san-critical' : state.san <= 40 ? 'san-low' : ''}`}>
                <LeftPanel state={state} buyItem={buyItem} />
                <CenterPanel state={state} event={event} isGenerating={isGenerating} isMobile={isMobile} choose={choose} hackState={hackState} hackStateRef={hackStateRef} setHackState={setHackState} handleHackResult={handleHackResult} logs={logs} terminalEndRef={terminalEndRef} />
                <div className="right-panel phone-scaler">
                  <PhoneOS isMobile={false} phoneData={phoneData} activeApp={activeApp} unread={unread} state={state} openApp={setActiveApp} onPhoneAction={handlePhoneAction} />
                </div>
              </div>
            )}
          </>
        )}
      </div>

      <FloatingMenu isMobile={isMobile} handleGlobalShare={handleGlobalShare} setModalType={setModalType} />
    </>
  );
}